import type { UnifyAppsAnalyticsClient } from './analytics';

type ClientWithHeartbeatTimer = { heartbeatIntervalId?: ReturnType<typeof setInterval> | null };

// The analytics-web client owns a heartbeat setInterval that its public API doesn't expose a stop
// for; clear it on unmount so a remount (or a route that tears the provider down) doesn't leak a
// second ticking timer. Shared by carbon's matrix provider and the app-builder-sdk's provider.
export function stopAnalyticsClient(client: UnifyAppsAnalyticsClient) {
  const timer = (client as unknown as ClientWithHeartbeatTimer).heartbeatIntervalId;
  if (timer) {
    clearInterval(timer);
  }
}
